import { mapOrderItemsQuantitiesForApi } from './mapOrderItemQuantitiesForApi'

/** Normaliza itens para calculate-total / calculate-total-taxes (mesma regra de defaultPrice do submit). */
export const mapOrderItemsForCalculateTotal = (items?: any[]) =>
  mapOrderItemsQuantitiesForApi(items).map((item) => ({
    ...item,
    salePrice: Number(item.salePrice),
    defaultPrice: Number(item.defaultPrice) || 0.01,
    currentPrice: Number(item.currentPrice ?? item.defaultPrice) || 0.01
  }))
